const Label = ({formName, formLabel}) => {
    return <label htmlFor={formName}>{formLabel}</label>
}
export default Label